import { IBudgetConstruction } from '@apply/api/src/api/ApplyApi';
import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetConstructionField } from '../../../../../queries/useBudgetConstructionField';

interface WellWaterProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const WellWater: React.FC<WellWaterProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [wellWater, set_wellWater] = useBudgetConstructionField<number>(
        propertyGuid,
        (b) => b.values?.['Site Work']?.['Well/Water'] ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Site Work': { ...b.values?.['Site Work'], 'Well/Water': v } } })
    );
    const label = 'Well/Water';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(wellWater)}
                />
            ) : (
                <MoneyBox
                    id={'wellWater'}
                    allowNegative={false}
                    value={wellWater}
                    onChange={(value) => set_wellWater(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
